/**
 * Session state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Session_State = {
	PENDING: "PENDING",
	RESERVATION_WAITING: "RESERVATION_WAITING",
	ACTIVE: "ACTIVE",
	COMPLETED: "COMPLETED",
	CANCELED: "CANCELED",
};

/**
 * Session payment state enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Session_PaymentState = {
	PENDING: "PENDING",
	ERROR: "ERROR",
	SUCCESS: "SUCCESS"
};

/**
 * Session type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Session_Type = {
	REGULAR: "REGULAR",
	DELIVERY_COURIER: "DELIVERY_COURIER",
	DELIVERY_CUSTOMER: "DELIVERY_CUSTOMER",
	RESERVATION: "RESERVATION"
}
